import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./ErrorMessage.module.less";

export type ErrorMessageProps = {
	message: string;
	trackingId?: string;
};

export const ErrorMessage = (props: ErrorMessageProps): ReactElement => {
	return (
		<p
			{...setTrackingId(props.trackingId)}
			className={styles.root}
		>
			{props.message}
		</p>
	);
};

ErrorMessage.displayName = "ErrorMessage";